export default __webpack_public_path__ + "static/media/clean.62a17498.png";